<template>
    <div class="history_search" v-if="showHistory" v-cloak>
        <div class="history-search">
            <div class="content-main">
                <div class="left-title">
                    <p>历史搜索</p>
                </div>
                <div class="right-title" @click.stop.prevent="removeAll">
                    <p>清空</p>
                    <img src="../../assets/images/parent-course/delete.png" alt="delete" />
                </div>
            </div>
        </div>
        <div class="keyword-arr">
            <ul class="key-ul">
                <li
                    class="key-li"
                    v-for="(item,index) in searchListShort"
                    :key="index"
                    @click="searchItem(item)"
                >
                {{ item.history }}
                <img @click.stop.prevent="removeThis(item)" src="@/assets/images/parent-course/tags-close.png" class="tags-close" alt="小叉号">
                </li>
                <li class="last-li" v-if="listFlag" @click.stop.prevent="showAll">
                    <p>展开</p>
                    <img src="../../assets/images/parent-course/barrow.png" alt />
                </li>
                <li class="last-li" v-if="listFlagUnshowAll" @click.stop.prevent="unshowAll">
                    <p>收起</p>
                    <img src="../../assets/images/parent-course/barrow.png" alt />
                </li>
            </ul>
        </div>
        <modal btnType="2" @submit="sure" @cancel="cancel">
            <template v-slot:body>
                <p>确认删除全部历史记录？</p>
            </template>
        </modal>
        <div class="loading_area">
            <loading v-if="loadingStatus1"></loading>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant';
import { _getSearchHistory, _delSearchHistory } from '../../api/parent-course'
import Modal from '../common/modal.vue';
import Loading from '@/components/common/is-loading'

export default {
    name: 'history-search',
    components: { Modal, Loading },
    props: {
        showHistory: {
            type: Boolean,
            default: false
        },
        searchedRecord: {
            type: Array,
            default: () => {
                return [{ key: '关键键词词' }, { key: '关关键词键词' }, { key: '关关键词键词' }, { key: '关键词关键词关键词' }, { key: '关键词' }, { key: '关键词' }, { key: '关键词' }, { key: '关键词' }, { key: '关键词' },]
            }
        }
    },
    data() {
        return {
            curShow: false,
            listFlagUnshowAll: false,
            loadingStatus1: false,
            searchList: [],
            searchListShort: [],
            showLists: false,
            listFlag: false,
        };
    },
    watch: {},
    computed: {},
    methods: {
        // 当获取到焦点的时候，重置关键词为部分显示
        ininShowFn() {
            this.$bus.$on('showMore', val => {
                // this.listFlag = true 暂时先为false
                this.listFlag = false
                this.listFlagUnshowAll = val
            })
        },
        async getSearchHistory() {
            this.loadingStatus1 = true
            // 获取历史搜索记录
            try {
                let res = await _getSearchHistory()
                this.loadingStatus1 = false
                let { code, message, data } = res
                if (res && code === 200) {
                    this.searchList = data
                } else {
                    this.searchList = []
                    Toast(message)
                }
                if (this.searchList.length > 8) {
                    let tempArr = this.searchList
                    this.listFlag = true
                    this.searchListShort = tempArr.slice(0, 8)
                } else {
                    this.searchListShort = this.searchList
                    this.listFlag = false
                }
                if (this.searchList.length === 0) {
                    // 传递历史搜索是否显示
                    this.$bus.$emit('showF', false)
                } else {
                    this.$bus.$emit('showF', true)
                }
            } catch (error) {
                this.loadingStatus1 = false
               
            }
        },
        cancel() {
            // 关闭弹框
            this.$bus.$emit('closeModal', false)
        },
        showAll() {
            this.searchListShort = this.searchList
            this.listFlagUnshowAll = true
            this.listFlag = false
        },
        unshowAll() {
            this.searchListShort = this.searchList.slice(0, 8)
            this.listFlagUnshowAll = false
            this.listFlag = true
        },
        // 清空搜索词
        removeAll() {
            this.$bus.$emit('closeModal', true)
        },
        removeThis(item) {
            this.delSearchHistory({
                'all': false,
                texts: [item.history]
            }).then(res => {
                console.log(res);
                if (res.code == 200 && res.data == '成功') {
                    this.getSearchHistory()
                }
            })
        },
        sure() {
            // 改变状态
            this.$emit('removeAll')
            // 调用清楚数据接口
            this.delSearchHistory({ 'all': true })
            // 关闭弹框
            this.$bus.$emit('closeModal', false)
        },
        //点击历史搜索关键词触发
        searchItem(item) {
            this.$emit('historyItem', item)
        },
        async delSearchHistory(delParams) {
            try {
                let res = await _delSearchHistory(delParams)
                let { code, data, message } = res
                if (res && code !== 200) {
                    Toast(message)
                } else {
                    Toast('删除成功')
                    return res
                }
            } catch (error) {
                
            }
        }
    },
    beforeCreate() { },
    created() {
        this.ininShowFn()
    },
    beforeMount() { },
    mounted() { },
    activated() { },
    deactivated() { },
    beforeDestroy() { },
    destroyed() { }
};
</script>

<style lang="scss">
.history_search {
    .history-search {
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 22px;
        // border: 1px solid red;
        .content-main {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 337px;
            height: 22px;
            // border: 1px solid blue;
            .right-title {
                display: flex;
                justify-content: center;
                align-items: center;
                p {
                    color: #666;
                }
            }
            .left-title {
                p {
                    font-weight: 500;
                    color: #2E4344;
                }
            }
            .left-title,
            .right-title {
                p {
                    height: 22px;
                    line-height: 22px;
                    font-size: 16px;
                }
                img {
                    width: 16px;
                    height: 16px;
                    margin-left: 6px;
                }
            }
        }
    }
    .keyword-arr {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 337px;
        .key-ul {
            display: flex;
            width: 335px;
            flex-wrap: wrap;
            .key-li {
                position: relative;
                line-height: 28px;
                 font-weight: 400;
                    margin-top: 12px;
                    margin-right: 15px;
                    padding: 0 20px;
                    background-color: #EDEFF2;
                    border-radius: 999px;
                    color: #626A6B;
                    .tags-close {
                position: absolute;
                width: 22px;
                height: 22px;
                top: -8px;
                right: -9px;
            }
            }
            
            .last-li {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 36px;
                // height: 17px;
                // line-height: 17px;
                p {
                    color: #ff8340;
                    font-size: 12px;
                }
                img {
                    width: 8px;
                    height: 8px;
                }
            }
        }
    }
}
[v-cloak] {
    display: none !important;
}
</style>
